import { render, staticRenderFns } from "./changelog-checklist.vue?vue&type=template&id=420379d6"
import script from "./changelog-checklist.vue?vue&type=script&lang=js"
export * from "./changelog-checklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports